module.exports = __webpack_public_path__ + "static/media/pill-box.ebbc5cf2.png";